
export default function About() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Security First',
      description: 'We prioritize the security of your mobile devices with cutting-edge encryption and protection mechanisms that keep your data safe from threats.'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'iOS Expertise',
      description: 'Our team specializes in iOS development, creating applications that leverage the full potential of Apple\'s ecosystem with native performance and design.'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'User-Centric Design',
      description: 'Every application we build focuses on delivering an exceptional user experience with intuitive interfaces and seamless interactions.'
    }
  ];

  return (
    <section id="about" className="py-32 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="mb-20">
          <div className="flex items-center gap-2 mb-6">
            <i className="ri-diamond-line text-cyan-500 text-xl"></i>
            <span className="text-sm uppercase tracking-wider text-slate-600 font-medium">Who We Are</span>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <h2 className="text-6xl font-bold text-slate-900 leading-tight">
              A Team of Experts Developing Modern Applications
            </h2>
            
            <p className="text-lg text-slate-600 leading-relaxed pt-4">
              BRANKOR DOO is dedicated to creating innovative iOS applications that transform how users interact with their mobile devices. Our expertise spans security, performance optimization, and user experience design, ensuring every product we deliver exceeds expectations.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-slate-100/50 rounded-3xl p-12 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-cyan-500/10 mb-8">
                <i className={`${feature.icon} text-3xl text-cyan-500`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-slate-900 mb-4">
                {feature.title}
              </h3>
              
              <p className="text-slate-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
